module.exports = {"440229100":"龙仙镇","440229104":"坝仔镇","440229106":"江尾镇","440229109":"官渡镇","440229111":"周陂镇","440229113":"翁城镇","440229114":"新江镇","440229450":"铁龙林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440229.json
// module id = 1790
// module chunks = 0